import { Box, Checkbox, Divider, Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { styled } from "@mui/styles";
import base from "../../api/apis";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import cardPlaceholder from "../../assets/propertyFavicon/savedHome.png";
import CreateNewFavoritePopUp from "./CreateNewFavoritePopUp";

// Custom dark btn
const CancelButton = styled(Button)(() => ({
  borderColor: "gray",
  color: "black",
  "&:hover": {
    borderColor: "gray",
  },
}));

export const SavedCardsModal = ({
  openFavoriteModal,
  setOpenFavoriteModal,
  categories,
  setCategories,
  primaryFavorite,
}) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { favorite } = state || {};
  const [loading, setLoading] = useState(false);
  const [createFavoritePopUp, setCreateFavoritePopUp] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);

  useEffect(() => {
    if (!primaryFavorite?.id) return;
    setSelectedCategory((p) =>
      Array.from(new Set([...p, primaryFavorite?.id]))
    );
  }, [primaryFavorite]);

  const handleClose = () => {
    setOpenFavoriteModal(false);
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const toggleItem = (item) => {
    setSelectedCategory((prevItems) => {
      if (prevItems?.includes(item)) {
        // Remove item if it's already in the array
        return prevItems.filter((i) => i !== item);
      } else {
        // Add item if it's not in the array
        return [...prevItems, item];
      }
    });
  };

  const saveCategoriesAddedOrRemoved = async () => {
    setLoading(true);

    try {
      await base.post("favorite/properties/", {
        ...favorite,
        category: selectedCategory,
      });
      setOpenFavoriteModal(false);
      dispatch({
        type: "SUCCESS",
        payload: "List Updated",
      });
    } catch (error) {
      dispatch({
        type: "ERROR",
        payload: "Error adding listing to category. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Check for image validity
  const ImageWithPlaceholder = ({ src, placeholder, alt }) => {
    const imgRef = useRef(null);
    const [thumbnailSrc, setThumbnailSrc] = useState(src);

    const defaultThumbnailSrc = placeholder;
    const handleImgValidity = () => {
      if (imgRef.current.naturalHeight <= 90 || null || undefined) {
        setThumbnailSrc(defaultThumbnailSrc);
      }
    };

    return (
      <img
        style={{
          height: "3rem",
          width: "4rem",
          borderRadius: 5,
          marginRight: 5,
        }}
        ref={imgRef}
        src={thumbnailSrc || defaultThumbnailSrc}
        onError={handleImgValidity}
        onLoad={handleImgValidity}
        alt={alt}
      />
    );
  };

  return (
    <>
      <Dialog
        open={openFavoriteModal}
        fullWidth={true}
        onClose={handleClose}
        maxWidth={"sm"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Add to List</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Button
              startIcon={
                <AddIcon
                  style={{
                    border: "solid blue 1px",
                    padding: " .8rem 1.1rem",

                    borderRadius: "5px",
                  }}
                />
              }
              fullWidth
              color="secondary"
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",
                textAlign: "start",
              }}
              onClick={() => {
                setCreateFavoritePopUp(true);
              }}
            >
              Create a new category
            </Button>
            {categories?.map((cat) => (
              <div key={cat?.id}>
                <Divider sx={{ mb: ".5rem" }} />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ display: "flex" }}>
                    <ImageWithPlaceholder
                      placeholder={cardPlaceholder}
                      src={cat?.favorite_images?.[0]}
                      alt="Just a random"
                    />
                    <Stack justifyContent="center" alignItems="flex-start">
                      <Typography>{cat?.name}</Typography>
                      {cat.is_primary && (
                        <Typography fontSize={12}>Primary List</Typography>
                      )}
                    </Stack>
                  </Box>
                  <Checkbox
                    {...label}
                    // disabled={
                    //   selectedCategory.length >= 2 &&
                    //   !selectedCategory.includes(cat.id)
                    // }
                    checked={selectedCategory.includes(cat.id)}
                    onClick={() => {
                      toggleItem(cat.id);
                    }}
                  />
                </Box>
                <Divider sx={{ mt: ".5rem" }} />
              </div>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton
            fullWidth
            variant="outlined"
            sx={{ textTransform: "none" }}
            onClick={handleClose}
          >
            Cancel
          </CancelButton>
          <LoadingButton
            color="secondary"
            sx={{ textTransform: "none" }}
            disableElevation
            fullWidth
            loading={loading}
            variant="contained"
            onClick={saveCategoriesAddedOrRemoved}
            autoFocus
          >
            Save
          </LoadingButton>
        </DialogActions>
      </Dialog>

      {createFavoritePopUp && (
        <CreateNewFavoritePopUp
          createFavoritePopUp={createFavoritePopUp}
          setCreateFavoritePopUp={setCreateFavoritePopUp}
          setCategories={setCategories}
          setSelectedCategory={setSelectedCategory}
        />
      )}
    </>
  );
};
